Vue.component('productdetailNonConfigurable', {
  data() {
    return {
      configurator3dopen: false,
      currentArticleCode: '',
        hbaFilterData: [],
        hbaInitialFilterData: [],
      selectedVariant: {
        articleCode: '',
        code: '',
        displayName: '',
        productDescription: '',
        maintenanceDescription: '',
        availableDescription: '',
        materialDescription: '',
        commercialDescription: '',
        materialDisplayName: '',
        materialDisplayName2: '',
        materialDisplayImageName: '',
        materialDisplayImageName2: '',
        materialCommercialDescription: '',
        materialCommercialDescription2: '',
        shape: '',
        safetyClass: '',
        fitting: '',
        lightType: '',
        kelvin: '',
        prodType: '',
        assemblyRequired: false,
        truckHi: false,
        parcelService: false,
        giftCertificate: false,
        lumen: '',
        color: '',
        style: '',
        dimmable: '',
        purchaseAvailableQuantity: 0,
        minimumStockQuantity: 0,
        safeOrderWeeksFromNow: 0,
        safeStockQuantity: 0,
        rawSafeStockQuantity: 0,
        countryBlockOrder: false,
        canOrderWithoutStock: false,
        bestBuy: false,
        outOfCollection: false,
        blockOrder: false,
        onlyParcelService: false,
        noDeliveryService: false,
        deliveryServicePlus: false,
        orderSplit: false,
        requestDeliveryInformation: false,
        useDenyWs: false,
        allowOrdersWithoutStock: false,
        webShopEnabled : false,
        requestQuote: false,
        noStock: false,
        quickDelivery: false,
        sale: false,
        actionFree: false,
        actionFreeText: '',
        productFullSizeAssetList: [],
        productAssetList: [],
        productThumbnailAssetList: [],
        crossSellProducts : [],
        oldPrice: '',
        ecoTax: '',
        warranty: '',
        price: '',
        colijnId: '',
        urlGlb: '',
        urlGlb2: '',
        urlUsdz: '',
        urlProductVideo: '',        
        enableVerticalPlacement: false,
        netWeight: 0,
        imgAltTag: '',
        height: '',
        width: '',
        backgroundColor: '',
        firstWeekAvailableText: '',
        firstWeekAvailable: 0,
        showFirstWeekAvailable: false,
        parts: [],
        oldPriceAmount: 0,
        priceAmount: 0,

        originalQuickDelivery : false,
        originalNoStock : false,
        originalPurchaseAvailableQuantity : 0,
        originalFirstWeekAvailableText : '',
        priginalFirstWeekAvailable : 0,
        originalShowFirstWeekAvailable : false

      },
      productDetailSlider: null,
      crossSellSlider: null,
      arSlider: null,
      arModal: null,
      qrModal: null,
      showModelViewerDimensions: false,
      zoomButtonPressed: false

    };
    },
  props: ['colijnurl'],
    mounted() {
        this.currentArticleCode = this.$el.dataset.articlecode;

        this.selectedVariant = jsonVariation;

        if (this.isOldChrome() && this.selectedVariant && this.selectedVariant.productThumbnailAssetList) {

            this.selectedVariant.productAssetList = this.selectedVariant.productAssetList.filter((element) => !element.href.includes('/Content/images/3dcustomize'));

            this.selectedVariant.productThumbnailAssetList = this.selectedVariant.productThumbnailAssetList.filter((element) => !element.href.includes('/Content/images/3dcustomize'));
        }

        this.hbaFilterData = jsonHbaFilterData;
        this.hbaInitialFilterData = /*Object.assign({}, this.hbaFilterData);*/ JSON.parse(JSON.stringify(this.hbaFilterData));

        if (this.currentArticleCode !== this.selectedVariant.articleCode) {
        this.currentArticleCode = this.selectedVariant.articleCode;
        }
        
        // Load Configurator with deeplink
        this.checkHash();

        var that = this;

        Vue.nextTick(() => {

            window.addEventListener('pageshow', (event) => {
              if (event.persisted) {
                window.location.reload();
              }
            });

            var asset3d = this.selectedVariant && this.selectedVariant.productAssetList && this.selectedVariant.productAssetList.find((element) => element.href.includes('/Content/images/3dcustomize'))
            if (asset3d) {

                const m = document.querySelector('#dimensionsviewer');

                if (m) {

                    m.addEventListener('progress', (event) => {
                        const progressBar = event.target.querySelector('.glb-progress-bar');
                        const updatingBar = event.target.querySelector('.glb-update-bar');
                        if (event.detail.totalProgress === 0) {
                            progressBar.style.display = 'block';
                            updatingBar.style.width = '0%';
                        } else {
                            updatingBar.style.width = `${event.detail.totalProgress * 100}%`;

                            if (event.detail.totalProgress === 1) {
                                setTimeout(() => {
                                    progressBar.style.display = 'none';
                                }, 500);
                            }
                        }
                    });

                    m.addEventListener('load', (event) => {

                        //const m = event.target;

                        m.addEventListener('camera-change', (dimev2) => {

                            app.renderModelViewerSVG(m, true);

                        });

                        let h = asset3d.h; // size.y
                        let d = asset3d.d; // size.z
                        let w = asset3d.w; // size.x

                        app.setModelViewerHotspot(m, h, d, w);

                        app.renderModelViewerSVG(m, true);

                        m.resetTurntableRotation(0);
                        m.setAttribute("camera-orbit", "45deg 75deg 114%");

                        setTimeout(() => {
                            app.setModelViewerVisibility(m, m.querySelector('#dimlines'), true);
                            m.querySelectorAll('button').forEach((hotspot) => {
                                app.setModelViewerVisibility(m, hotspot, true);
                            });
                        }, 100);

                        const zoomOut = m.querySelector('#dimensionzoom-out');

                        zoomOut.addEventListener('click', (zoomevt) => {

                            if (document.body.style.overflow === "hidden") {

                                setTimeout(() => {
                                    this.ModelViewerNormalScreen('dimensionsviewer', '#dimensionmodelviewerzoom');
                                }, 0);

                            } else {
                                setTimeout(() => {
                                    this.ModelViewerFullScreen('dimensionsviewer', '#dimensionmodelviewerzoom', false);
                                }, 0);

                            }
                            
                        });
                    });
                }

            }

            var handlearusdzbutton = document.getElementById('handlearusdzbutton');
            if (handlearusdzbutton != null) {
                handlearusdzbutton.addEventListener("message",
                    function (event) {
                        if (event.data === "_apple_ar_quicklook_button_tapped") {

                            setTimeout(() => {

                                that.$emit('add-product');

                                that.sendArLogging('CART', that.selectedVariant.code);

                                //app.addOrUpdateCart(that.selectedVariant.code, that.selectedVariant.displayName, 1, null, null, null, null, 0, 0, null, true, null, null, null, 0);

                                app.$refs.shoppinglistheaderbutton.click();

                            }, 400);

                        }
                    });
            };

        });

        window.addEventListener('keyup', (keyevt) => {

            if (document.body.style.overflow === "hidden" && keyevt.key === "Escape") {

                this.ModelViewerNormalScreen('modelviewer', '#modelviewerzoom');

                this.ModelViewerNormalScreen('dimensionsviewer', '#dimensionmodelviewerzoom');
            }
        });

        window.addEventListener('resize', (resizeevt) => {

            if (document.body.style.overflow === "hidden") {

                this.ModelViewerFullScreen('modelviewer', '#modelviewerzoom', true);

                this.ModelViewerFullScreen('dimensionsviewer', '#dimensionmodelviewerzoom', true);
            }

        });

    },
  watch: {
    selectedVariant(newVariant, oldVariant) {
      if (oldVariant.articleCode !== '' && newVariant.articleCode !== oldVariant.articleCode) {
          this.updateImageSlider();
          this.updateCSImageSlider();
      }
    },
    productDetailSlider() {
      this.updateImageSlider();
      },
    crossSellSlider() {
        this.updateCSImageSlider();
    },
  },
  computed: {

  },
  methods: {
      isOldChrome() {
        const match = window.navigator.userAgent.match(/Chrome\/(\d+)/i);
        return match ? parseInt(match[1], 10) <= 70 : false;
      },
      makeAChoiceIsActive(index1, options) {

          if (options) {
              let activeItem = options.find(function (option) {
                  return false;
              });

              if (activeItem) {
                  return false;
              }
          }
          return true;
      },

      activeHbaLabel(index1,options) {

          if (options) {
              let activeItem = options.find(function (option) {
                  return option.active;
              });

              if (activeItem) {
                  return activeItem.label;
              } else {
                  /*
                  var initialActiveOption = this.hbaInitialFilterData[index1].options.find(option => option.active);

                  if (initialActiveOption) {
                      var option2 = options.find(option => option.id === initialActiveOption.id);

                      if (option2 && option2.count > 0) {
                              option2.active = true;
                      }
                  }*/

              }
          }

          var dropdown = document.querySelector('#hba1_' + index1);

          if (dropdown &&!dropdown.classList.contains('dropdown__toggle--open')) {
            dropdown.click();
          }

          return "<strong><span style=\"color:red;\">" + hbaMakeAChoiceText + "<span></strong>";
      },

      activeHbaId(index1, options) {

          if (options) {
              let activeItem = options.find(function (option) {
                  return option.active;
              });

              if (activeItem) {
                  return activeItem.id;
              } 
          }

          return "";
      },

      activeHbaBackground(index1, options) {

          if (options) {
              let activeItem = options.find(function (option) {
                  return option.active;
              });

              if (activeItem) {

                  var initialActiveOption = this.hbaInitialFilterData[index1].options.find(option => option.id === activeItem.id);

                  if (initialActiveOption && initialActiveOption.active !== activeItem.active) {

                    return "border:1px solid red;"
                  }

                  return "";
              }
          }

          var makeAChoiceIsActive = this.makeAChoiceIsActive(index1, options);

          if (makeAChoiceIsActive) {
              return "border:2px solid red;"
          }
          else {
              return "border:1px solid red;"
          }
      },

      activeHbaImageUrl(options) {
          if (options) {
              let activeItem = options.find(function (option) {
                  return option.active;
              });

              if (activeItem) {
                  return activeItem.imageurl;
              }
          }
          return '';
      },

      selectHbaFilterData(index1, id, code, articlecode, collection) {

          var currentSelection = this.hbaFilterData[index1].options.find(option => option.id === id);

          if (currentSelection != null && currentSelection.active !== true) {

              this.hbaFilterData[index1].options.forEach((option) => {

                  option.active = false;
              });
              currentSelection.active = true;

              if (currentSelection.count === 1 && currentSelection.url) {

                window.location.href = currentSelection.url;
                return;
              }

              /*this.hbaFilterData.forEach((hbaClass) => {

                  hbaClass.options.forEach((option) => {

                      option.active = false;
                  });

              });

              currentSelection.active = true;
              */

              var json = JSON.stringify({
                  HbaFilters: this.hbaFilterData,
                  Code: code,
                  ArticleCode: articlecode,
                  Collection: collection,
                  CharacteristicSubClass: this.hbaFilterData[index1].characteristicSubClass,
                  Id: currentSelection.id
              });


              fetch('/api/cart/hbadropdown',
                  {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                          'Accept-Language': document.documentElement.lang,
                          'X-Requested-With': 'XMLHttpRequest'
                      },
                      credentials: 'same-origin',
                      body: json
                  }).then(response => response.json()).then((data) => {

                      if (data) {
                          this.hbaFilterData = data;

                          var currentSelection2 = this.hbaFilterData[index1].options.find(option => option.id === id);

                          if (currentSelection2 != null && currentSelection2.count === 1 && currentSelection2.url) {
                            window.location.href = currentSelection2.url;
                            return;
                          }

                          // check if all options have count = 1 then jump
                      }

                  });


              //currentSelection.label
              //currentSelection.count
              //currentSelection.articleCode
              //currentSelection.id
              //currentSelection.active

          }
      },

      toPriceString(value, hostLanguage, conceptCode) {

          var v = '';

          //var w = value.toLocaleString(hostLanguage, { style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: 'EUR' });

          switch (hostLanguage) {
              case 'en-NL':
              case 'nl-BE':
              case 'fr-BE':
              case 'de-BE':
              case 'de-AT':
                  v = new Intl.NumberFormat('nl', { style: 'currency', trailingZeroDisplay: "stripIfInteger", minimumFractionDigits: 2, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
                  if (Number(value) === value && value % 1 === 0) v += ',-';
                  break;
              case 'de':
              case 'fr-LU':
              case 'de-LU':
                  v = new Intl.NumberFormat(hostLanguage, { style: 'currency', trailingZeroDisplay: "stripIfInteger", minimumFractionDigits: 2, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
                  if (Number(value) === value && value % 1 === 0) v = v.replace(/\xA0/g, ',-' + String.fromCharCode(0xA0));
                  break;
              case 'de-CH':
              case 'fr-CH':
                  v = new Intl.NumberFormat(hostLanguage, { style: 'currency', trailingZeroDisplay: "stripIfInteger", minimumFractionDigits: 2, maximumFractionDigits: 2, currency: 'CHF' }).format(value);
                  if (Number(value) === value && value % 1 === 0) v = v.replace(/\xA0/g, '.-' + String.fromCharCode(0xA0));
                  break;
              case 'en-IE':
                  v = new Intl.NumberFormat(hostLanguage, { style: 'currency', trailingZeroDisplay: "stripIfInteger", minimumFractionDigits: 2, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
                  if (Number(value) === value && value % 1 === 0) v += '.-';
                  break;
              case 'en-GB':
                  v = new Intl.NumberFormat(hostLanguage, { style: 'currency', trailingZeroDisplay: "stripIfInteger", minimumFractionDigits: 2, maximumFractionDigits: 2, currency: 'GBP' }).format(value);
                  if (Number(value) === value && value % 1 === 0) v += '.-';
                  break;
              default:
                  if (hostLanguage === "nl" && conceptCode === "XN") { // no euro sign for XOOON.NL
                      v = new Intl.NumberFormat(hostLanguage, { trailingZeroDisplay: "stripIfInteger", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
                      if (Number(value) === value && value % 1 === 0 && hostLanguage !== "fr") v += ',-';
                  }
                  else {
                      v = new Intl.NumberFormat(hostLanguage, { style: 'currency', trailingZeroDisplay: "stripIfInteger", minimumFractionDigits: 2, maximumFractionDigits: 2, currency: 'EUR' }).format(value);
                      // remove ,- for France and HENDERSANDHAZEL.NL
                      if (Number(value) === value && value % 1 === 0 && hostLanguage !== "fr" && !(hostLanguage === "nl" && conceptCode === "HH")) v += ',-';
                  }
          }
         
          return v.replace(/\u00A0/g, ' ');
      },

      selectPart(index1, index2, hostLanguage, conceptCode) {

          var totalPriceAmount = 0;
          var totalOldPriceAmount = 0;
          var totalEcoTaxAmount = 0;

          this.selectedVariant.parts[index1].selectedItemDescription = this.selectedVariant.parts[index1].items[index2].description;
          this.selectedVariant.parts[index1].selectedprodId = this.selectedVariant.parts[index1].items[index2].prodId;

          this.selectedVariant.parts[index1].selectedPrice = this.selectedVariant.parts[index1].items[index2].price;
          this.selectedVariant.parts[index1].selectedOldPrice = this.selectedVariant.parts[index1].items[index2].oldPrice;
          this.selectedVariant.parts[index1].selectedEcoTax = this.selectedVariant.parts[index1].items[index2].ecoTax;

          this.selectedVariant.parts[index1].selectedPriceAmount = this.selectedVariant.parts[index1].items[index2].priceAmount;
          this.selectedVariant.parts[index1].selectedOldPriceAmount = this.selectedVariant.parts[index1].items[index2].oldPriceAmount;
          this.selectedVariant.parts[index1].selectedEcoTax = this.selectedVariant.parts[index1].items[index2].oldEcoTax;

          this.selectedVariant.parts.forEach((part, index) => {
              totalPriceAmount += part.selectedPriceAmount;
              totalOldPriceAmount += part.selectedOldPriceAmount;
              totalEcoTaxAmount += part.selectedEcoTaxAmount;
          });

          totalPriceAmount += this.selectedVariant.priceAmount;
          totalOldPriceAmount += this.selectedVariant.oldPriceAmount;
          totalEcoTaxAmount += this.selectedVariant.ecoTaxAmount;

          this.selectedVariant.price = this.toPriceString(totalPriceAmount, hostLanguage, conceptCode);

          if (totalEcoTaxAmount > 0) {
              this.selectedVariant.ecoTax = this.selectedVariant.parts[index1].ecoTaxString.replace("{EcoTax}",this.toPriceString(totalEcoTaxAmount, hostLanguage, conceptCode));
          } else {
              this.selectedVariant.ecoTax = "";
          }

          if (totalOldPriceAmount !== totalPriceAmount) {
              this.selectedVariant.oldPrice = this.toPriceString(this.selectedVariant.oldPriceAmount + this.selectedVariant.parts[index1].selectedOldPriceAmount, hostLanguage, conceptCode);
          } else {
              this.selectedVariant.oldPrice = "";
          }

          this.selectedVariant.parts[index1].selectedQuickDelivery = this.selectedVariant.parts[index1].items[index2].quickDelivery;
          this.selectedVariant.parts[index1].selectedNoStock = this.selectedVariant.parts[index1].items[index2].noStock;
          this.selectedVariant.parts[index1].selectedPurchaseAvailableQuantity = this.selectedVariant.parts[index1].items[index2].purchaseAvailableQuantity;
          this.selectedVariant.parts[index1].selectedFirstWeekAvailableText = this.selectedVariant.parts[index1].items[index2].firstWeekAvailableText;
          this.selectedVariant.parts[index1].selectedFirstWeekAvailable = this.selectedVariant.parts[index1].items[index2].firstWeekAvailable;
          this.selectedVariant.parts[index1].selectedShowFirstWeekAvailable = this.selectedVariant.parts[index1].items[index2].showFirstWeekAvailable;

          this.selectedVariant.quickDelivery = this.selectedVariant.originalQuickDelivery;
          this.selectedVariant.noStock = this.selectedVariant.originalNoStock;
          this.selectedVariant.purchaseAvailableQuantity = this.selectedVariant.originalPurchaseAvailableQuantity;
          this.selectedVariant.firstWeekAvailableText = this.selectedVariant.originalFirstWeekAvailableText;
          this.selectedVariant.firstWeekAvailable = this.selectedVariant.originalFirstWeekAvailable;
          this.selectedVariant.showFirstWeekAvailable = this.selectedVariant.originalShowFirstWeekAvailable;

          var highestFirstWeekavailable = this.selectedVariant.firstWeekAvailable;
          if (this.selectedVariant.purchaseAvailableQuantity > 0 || highestFirstWeekavailable === 999999) {
              highestFirstWeekavailable = 0;
          }

          var noStockFound = false;

          this.selectedVariant.parts.forEach((part, i) => {

              if (part.selectedPurchaseAvailableQuantity <= 0 &&
                  part.selectedFirstWeekAvailable !== 999999 &&
                  part.selectedFirstWeekAvailable > highestFirstWeekavailable) {

                  highestFirstWeekavailable = part.selectedFirstWeekAvailable;

                  this.selectedVariant.firstWeekAvailable = part.selectedFirstWeekAvailable;
                  this.selectedVariant.purchaseAvailableQuantity = part.selectedPurchaseAvailableQuantity;
                  this.selectedVariant.quickDelivery = part.selectedQuickDelivery;
                  this.selectedVariant.firstWeekAvailableText = part.selectedFirstWeekAvailableText;
                  this.selectedVariant.showFirstWeekAvailable = part.selectedFirstWeekAvailable;
                  this.selectedVariant.noStock = part.selectedNoStock;

                  noStockFound = true;
              }
          });

          if (!noStockFound) {
              this.selectedVariant.parts.forEach((part, i) => {

                  if (part.selectedPurchaseAvailableQuantity > 0 &&
                      part.selectedPurchaseAvailableQuantity < this.selectedVariant.purchaseAvailableQuantity) {

                      this.selectedVariant.firstWeekAvailable = 0;
                      this.selectedVariant.purchaseAvailableQuantity = part.selectedPurchaseAvailableQuantity;
                      this.selectedVariant.quickDelivery = part.selectedQuickDelivery;
                      this.selectedVariant.firstWeekAvailableText = part.selectedFirstWeekAvailableText;
                      this.selectedVariant.showFirstWeekAvailable = part.selectedShowFirstWeekAvailable;
                      this.selectedVariant.noStock = part.selectedNoStock;
                  }

              });
          }

      },

      sendArLogging(type, code) {

          fetch('/api/cart/arlog',
              {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept-Language': document.documentElement.lang,
                      'X-Requested-With': 'XMLHttpRequest'
                  },
                  credentials: 'same-origin',
                  body: JSON.stringify({
                      Type: type,
                      Code: code.replace('p-', '')
                  })
              }).then((response) => {

              });
      },

      handleqr(event, code) {

          this.sendArLogging('QR', code);

         this.qrModal = new Modal(document.querySelector('.js-qr-modal'));

         this.qrModal.open();

         if (event) {
            event.preventDefault()
         }

         return false;
      },

      handleusdz(event, url, force, code) {

          if (force === 2 || (force === 0 && docCookies.getItem('arhelp') === null)) {
              this.arModal = new Modal(document.querySelector('.js-ar-modal'));

              this.arModal.open();

              this.arSlider.select(0, false, true);
              this.arSlider.resize();

              if (event) {
                  event.preventDefault()
              }

              return false;
          } 

          if (this.arModal) {
              this.arModal.close();
          }

          this.sendArLogging('IPHONE', code);

          docCookies.setItem('arhelp', '1', Infinity, '/');

          return true;
      },

      handlearglb(event, url, force, enableVerticalPlacement, code) {

          if (force === 2 || (force === 0 && docCookies.getItem('arhelp') === null)) {
              this.arModal = new Modal(document.querySelector('.js-ar-modal'));

              this.arModal.open();

              this.arSlider.select(0, false, true);
              this.arSlider.resize();

              if (event) {
                  event.preventDefault()
              }

              return false;
          } 

          if (this.arModal) {
              this.arModal.close();
          }

          this.sendArLogging('ANDROID', code);

          docCookies.setItem('arhelp', '1', Infinity, '/');

          var vp = '';
          if (enableVerticalPlacement) {
              vp = 'enable_vertical_placement=true&';
          }

          var arurl = 'intent://arvr.google.com/scene-viewer/1.0?' +
              vp +
              'file=' +
              url +
              '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;end;';

          window.location.href = arurl;

          return true;
    },

    onSliderReady() {
      this.setImageSlider();
      this.setCSImageSlider();
      this.setarSlider();

    },

    setarSlider() {
      this.arSlider = Flickity.data('.js-sliderar');
    },
    setImageSlider() {
      this.productDetailSlider = Flickity.data('.productdetail__slider__main');
    },
    setCSImageSlider() {
      this.crossSellSlider = Flickity.data('.js-slidercs');
    },

    htmlToElement(html) {
        let template = document.createElement('template');
        template.innerHTML = html;
        return template.content.firstChild;
    },


    ModelViewerFullScreen(modelViewerId, buttonIconId, resize) {

        var fullHeight = window.innerHeight + "px";

        const modelviewerid = document.getElementById(modelViewerId);

        if (modelviewerid && ((modelviewerid.style.height === "100%" && !resize) ||
            (modelviewerid.style.height !== "100%" && resize))) {

            this.zoomButtonPressed = true;

            const useElem = document.querySelector(buttonIconId);

            document.body.style.overflow = "hidden";

            if (modelViewerId !== 'dimensionsviewer') {
                useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomout');

                const elements = document.getElementsByClassName('productdetail__slider__main');
                const el = elements[0];
                el.style.width = "100vw";
                el.style.height = fullHeight;
                el.style.position = "fixed";
                el.style.backgroundColor = "#ffffff";
                el.style.top = "0";
                el.style.left = "0";
                el.style.zIndex = "50";

                const elements2 = el.querySelector('.flickity-page-dots');
                if (elements2) {
                    const el2 = elements2;
                    el2.style.display = "none";
                }
                const elements3 = el.querySelector('.flickity-viewport');
                if (elements3) {
                    const el3 = elements3;
                    el3.style.minHeight = fullHeight;
                }
            } else {
                useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomout');

                const elements = document.getElementsByClassName('dimension-Viewer');
                const el = elements[0];
                el.style.width = "100vw";
                el.style.height = fullHeight;
                el.style.position = "fixed";
                el.style.backgroundColor = "#ffffff";
                el.style.top = "0";
                el.style.left = "0";
                el.style.zIndex = "50";
            }

            modelviewerid.style.height = fullHeight; // 100%

        }

    },

    ModelViewerNormalScreen(modelViewerId, buttonIconId) {

        const modelviewerid = document.getElementById(modelViewerId);

        this.zoomButtonPressed = true;

        const useElem = document.querySelector(buttonIconId);

        document.body.style.overflow = "";

        if (modelViewerId !== 'dimensionsviewer') {
            useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#3drotate');

            const elements = document.getElementsByClassName('productdetail__slider__main');
            const el = elements[0];
            el.style.width = "";
            el.style.height = "";
            el.style.position = "";
            el.style.backgroundColor = "";
            el.style.top = "";
            el.style.left = "";
            el.style.zIndex = "";

            const elements2 = el.querySelector('.flickity-page-dots');
            if (elements2) {
                const el2 = elements2;
                el2.style.display = "";
            }

            const elements3 = el.querySelector('.flickity-viewport');
            if (elements3) {
                const el3 = elements3;
                el3.style.minHeight = "";
            }
        } else {
            useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomin');

            const elements = document.getElementsByClassName('dimension-Viewer');
            const el = elements[0];
            el.style.width = "";
            el.style.height = "";
            el.style.position = "";
            el.style.backgroundColor = "";
            el.style.top = "";
            el.style.left = "";
            el.style.zIndex = "";
        }

        modelviewerid.style.height = "100%"; // 100%

    },

    updateImageSlider() {

      if (this.productDetailSlider) {
          const newSlides = [];

          var sliderHeight = "200px";
          var tall = document.getElementsByClassName('productdetail__slider__main--tall');
          if (tall && tall.length > 0) {
              sliderHeight = "400px";
          }

          if (this.productDetailSlider.cells.length) {
            this.productDetailSlider.remove(this.productDetailSlider.cells.map(cell => cell.element));
          }

          this.selectedVariant.productAssetList.forEach((asset, i) => {
            if (true /*i < 7*/) {

                if (i===0 && asset.showDimensions) {

                    const newSlide = document.createElement('div');
                    newSlide.className = 'productdetail__slider__item';
                    newSlide.style = `min-height:${sliderHeight};`;

                    const newSlide2 = document.createElement('div');
                    newSlide2.style = "text-align:center;flex-direction:row;display:flex;margin-top:auto;margin-bottom:auto;flex-flow:row;flex-wrap:nowrap;flex-align:row;"

                    const newSlideImg = document.createElement('img');
                    newSlideImg.src = asset.href.replace("height=650", "height=625").replace("t_n", "t_ns");
                    newSlideImg.setAttribute('data-src-zoom', this.selectedVariant.productFullSizeAssetList[i].href);
                    newSlideImg.setAttribute('alt', this.selectedVariant.imgAltTag);
                    newSlideImg.style = `object-fit:contain;min-height:${sliderHeight};`;

                    const newvertDiv1 = document.createElement('div');
                    newvertDiv1.style = "width:20px;margin-bottom:25px; border-right:1px solid #222; margin-right:5px;display:flex;text-align:center;flex-direction:column;"

                    const newvertDiv2 = document.createElement('div');
                    newvertDiv2.style = "flex-grow:1;width:5px;border-top:1px solid #222;margin-left:15px;";

                    newvertDiv1.appendChild(newvertDiv2);

                    const newvertDiv3 = document.createElement('div');
                    newvertDiv3.innerHTML = this.selectedVariant.height;
                    //newvertDiv2.style = "padding-left:75px;padding-top:30px;position: absolute;top: 50%;transform: translateX(-50%) rotate(-90deg);text-align:center;";
                    newvertDiv3.style = "text-orientation: sideways;  writing-mode: vertical-rl; ";

                    newvertDiv1.appendChild(newvertDiv3);

                    const newvertDiv4 = document.createElement('div');
                    newvertDiv4.style = "flex-grow:1;width:5px;border-bottom:1px solid #222;margin-left:15px;";
                    newvertDiv1.appendChild(newvertDiv4);

                    newSlide2.appendChild(newvertDiv1);

                    const newSlideImgDiv = document.createElement('div');
                    newSlideImgDiv.appendChild(newSlideImg);

                    const newhorDiv = document.createElement('div');
                    newhorDiv.className = "productdetail__slider--measurement";
                    newhorDiv.style = ""

                    const newhorDiv2 = document.createElement('div');
                    newhorDiv2.style = "margin-top:4px;display:flex;flex-wrap:nowrap;flex-align:row;"

                    const newhorDiv3 = document.createElement('div');
                    newhorDiv3.style = "flex-grow:1;height:5px;border-left:1px solid #222;border-top: 1px solid #222;"
                    newhorDiv3.innerHTML = "";

                    newhorDiv2.appendChild(newhorDiv3);

                    const newhorDiv4 = document.createElement('div');
                    newhorDiv4.style = "border-top: 1px solid #222;"
                    newhorDiv4.innerHTML = this.selectedVariant.width;

                    newhorDiv2.appendChild(newhorDiv4);

                    const newhorDiv5 = document.createElement('div');
                    newhorDiv5.style = "flex-grow:1;height:5px;border-right:1px solid #222; border-top: 1px solid #222;"
                    newhorDiv5.innerHTML = "";

                    newhorDiv2.appendChild(newhorDiv5);

                    newhorDiv.appendChild(newhorDiv2);

                    newSlideImgDiv.appendChild(newhorDiv);

                    newSlide2.appendChild(newSlideImgDiv);

                    newSlide.appendChild(newSlide2);

                    newSlides.push(newSlide);

                } else {

                    const newSlide = document.createElement('div');
                    newSlide.className = 'productdetail__slider__item';
                    newSlide.style = `min-height:${sliderHeight};`;

                    const newSlide2 = document.createElement('div');

                    if (asset.href.includes('/Content/images/productvideo')) {
                        newSlide2.id = "videoviewer";
                        newSlide2.style = "text-align:center;flex-direction:row;display:flex;margin-top:auto;margin-bottom:auto;flex-flow:column;width:100%;" //height:100%;"

                        const newSlideDiv = document.createElement('video');
                        newSlideDiv.className = "videoviewer";
                        //newSlideDiv.style.width = "100%";
                        //newSlideDiv.style.height = "100%";
                        newSlideDiv.controls = true;
                        newSlideDiv.controlsList = "nodownload";
                        newSlideDiv.autoplay = true;
                        newSlideDiv.muted = true;

                        var sourceMP4 = document.createElement("source"); 
                        sourceMP4.type = "video/mp4";
                        sourceMP4.src = this.selectedVariant.urlProductVideo;

                        newSlideDiv.appendChild(sourceMP4);

                        newSlide2.appendChild(newSlideDiv);

                    }
                    else if (asset.href.includes('/Content/images/3dcustomize')) {

                        newSlide2.id = "modelviewer";
                        newSlide2.style = "text-align:center;flex-direction:row;display:flex;margin-top:auto;margin-bottom:auto;flex-flow:column;width:100%;height:100%;"

                        /*const mv = document.createElement("babylon");
                        mv.style = `height:100%;width:100%;min-height:${sliderHeight};background-color:unset;`;
                        mv.setAttribute("model", this.selectedVariant.urlGlb2);
                        //mv.setAttribute("templates.main.params.fill-screen", "true");
                        mv.setAttribute("templates.nav-bar.html", "<div/>");*/

                        this.showModelViewerDimensions = false;

                        const mv = document.createElement("model-viewer");
                        mv.style = `height:100%;width:99.9%;min-height:${sliderHeight};background-color:unset;`;
                        mv.setAttribute("src", this.selectedVariant.urlGlb2);
                        //mv.setAttribute("ios-src", this.selectedVariant.urlUsdz);
                        mv.setAttribute("alt", this.selectedVariant.imgAltTag);
                        //mv.setAttribute("poster", "/Content/images/3dcustomize@2x.png");

                        //mv.setAttribute("preload", "");
                        mv.setAttribute("loading", "auto");

                        //mv.setAttribut("ar-modes", "webxr scene-viewer quick-look");
                        //mv.setAttribute("ar-scale", "auto");
                        //mv.setAttribute("ar", "");

                        mv.setAttribute("auto-rotate", "");
                        mv.setAttribute("auto-rotate-delay", "1000");

                        mv.setAttribute("min-camera-orbit", "auto 0deg 50%");
                        mv.setAttribute("max-camera-orbit", "auto 180deg 150%");

                        mv.setAttribute("camera-orbit", "45deg 75deg 114%");
                        //mv.setAttribute("camera-controls","");
                        mv.setAttribute("interaction-prompt","none");
                        mv.setAttribute("interaction-prompt-style","basic");
                        mv.setAttribute("touch-action", "none");

                        mv.setAttribute("shadow-intensity", "1");

                        //mv.setAttribute("exposure", "1");
                        //mv.setAttribute("environment-image", "neutral");
                        //mv.setAttribute("environment-image","/Content/3d/envbpneutral1.hdr");
                        //mv.setAttribute("environment-image","/Content/3d/envlightroom2.hdr");
                        //mv.setAttribute("environment-image","/Content/3d/envstudiob2.hdr");

                        mv.appendChild(this.htmlToElement(`<div slot="progress-bar" class="glb-progress-bar"><div class="glb-update-bar"></div></div>`));

                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dot+X-Y+Z" class="modelViewer-Dot modelViewer-Hide" data-position="1 -1 1" data-normal="1 0 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dim+X-Y" class="modelViewer-Dim modelViewer-Dim--nopadding modelViewer-Hide" data-position="1 -1 0" data-normal="1 0 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dot+X-Y-Z" class="modelViewer-Dot modelViewer-Hide" data-position="1 -1 -1" data-normal="1 0 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dim+X-Z" class="modelViewer-Dim modelViewer-Dim--nopadding modelViewer-Hide" data-position="1 0 -1" data-normal="1 0 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dot+X+Y-Z" class="modelViewer-Dot modelViewer-Hide" data-position="1 1 -1" data-normal="0 1 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dim+Y-Z" class="modelViewer-Dim modelViewer-Dim--nopadding modelViewer-Hide" data-position="0 -1 -1" data-normal="0 1 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dot-X+Y-Z" class="modelViewer-Dot modelViewer-Hide" data-position="-1 1 -1" data-normal="0 1 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dim-X-Z" class="modelViewer-Dim modelViewer-Dim--nopadding modelViewer-Hide" data-position="-1 0 -1" data-normal="-1 0 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dot-X-Y-Z" class="modelViewer-Dot modelViewer-Hide" data-position="-1 -1 -1" data-normal="-1 0 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dim-X-Y" class="modelViewer-Dim modelViewer-Dim--nopadding modelViewer-Hide" data-position="-1 -1 0" data-normal="-1 0 0"></button>`));
                        mv.appendChild(this.htmlToElement(`<button slot="hotspot-dot-X-Y+Z" class="modelViewer-Dot modelViewer-Hide" data-position="-1 -1 1" data-normal="-1 0 0"></button>`));
                        
                        mv.appendChild(this.htmlToElement(`<svg id="dimlines" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="modelViewer-DimensionLineContainer">` +
                            `<line class="modelViewer-DimensionLine modelViewer-Hide"></line>` +
                            `<line class="modelViewer-DimensionLine modelViewer-Hide"></line>` +
                            `<line class="modelViewer-DimensionLine modelViewer-Hide"></line>` +
                            `<line class="modelViewer-DimensionLine modelViewer-Hide"></line>` +
                            `<line class="modelViewer-DimensionLine modelViewer-Hide"></line>` +
                            `</svg>`));

                        mv.appendChild(this.htmlToElement(`<div id="show-dimensions" class="modelViewer-Dim modelViewer-Button1">` +
                            `<svg class="icon" style="position:unset; height:30px; width:30px;"><use xlink:href="#ruler"></use></svg>` +
                            `</div>`));

                        mv.appendChild(this.htmlToElement(`<div id="zoom-out" class="modelViewer-Dim modelViewer-Button2 button--dark">` +
                            `<svg class="icon" style="position:unset; height:30px; width:30px;"><use id="modelviewerzoom" xlink:href="#3drotate"></use></svg>` +
                            `</div>`));

                        newSlide2.appendChild(mv);

                        mv.addEventListener('progress', (event) => {
                            const progressBar = event.target.querySelector('.glb-progress-bar');
                            const updatingBar = event.target.querySelector('.glb-update-bar');
                            if (event.detail.totalProgress === 0) {
                                progressBar.style.display = 'block';
                                updatingBar.style.width = '0%';
                            } else {
                                updatingBar.style.width = `${event.detail.totalProgress * 100}%`;

                                if (event.detail.totalProgress === 1) {
                                    setTimeout(() => {
                                        progressBar.style.display = 'none';
                                    }, 500);
                                }
                            }
                        });

                        mv.addEventListener('load', (event) => {

                            const m = event.target;

                            m.addEventListener('camera-change', (ev) => {

                                const mm = ev.target;

                                app.renderModelViewerSVG(mm, this.showModelViewerDimensions);

                                if (!this.zoomButtonPressed) {
                                    mm.removeAttribute("auto-rotate");
                                } else {
                                    setTimeout(() => {
                                        this.zoomButtonPressed = false;
                                    }, 100);
                                }
                            });

                            app.setModelViewerHotspot(m, asset.h, asset.d, asset.w);

                            app.renderModelViewerSVG(m, this.showModelViewerDimensions);
                        });

                        const showDimensions = mv.querySelector('#show-dimensions');

                        showDimensions.addEventListener('click', (event) => {

                            const modelViewer = event.target.closest('model-viewer');

                            this.showModelViewerDimensions = !this.showModelViewerDimensions;

                            if (this.showModelViewerDimensions) {
                                modelViewer.resetTurntableRotation(0);
                                modelViewer.setAttribute("camera-orbit", "45deg 75deg 114%");
                            }

                            setTimeout(() => {
                                app.setModelViewerVisibility(modelViewer, modelViewer.querySelector('#dimlines'), this.showModelViewerDimensions);
                                modelViewer.querySelectorAll('button').forEach((hotspot) => {
                                    app.setModelViewerVisibility(modelViewer, hotspot, this.showModelViewerDimensions);
                                });
                            }, 100);

                        });

                        const zoomOut = mv.querySelector('#zoom-out');

                        zoomOut.addEventListener('click', (event) => {

                            const modelViewer = event.target.closest('model-viewer');

                            if (document.body.style.overflow === "hidden") {

                                this.ModelViewerNormalScreen('modelviewer', '#modelviewerzoom');

                                modelViewer.removeAttribute("camera-controls");

                                modelViewer.resetTurntableRotation(0);
                                modelViewer.setAttribute("camera-orbit", "45deg 75deg 114%");
                                modelViewer.setAttribute("camera-target", "auto auto auto");
                                modelViewer.setAttribute("auto-rotate", "");

                                if (this.showModelViewerDimensions) {
                                    this.showModelViewerDimensions = false;

                                    setTimeout(() => {
                                        app.setModelViewerVisibility(modelViewer, modelViewer.querySelector('#dimlines'), this.showModelViewerDimensions);
                                        modelViewer.querySelectorAll('button').forEach((hotspot) => {
                                            app.setModelViewerVisibility(modelViewer, hotspot, this.showModelViewerDimensions);
                                        });
                                    }, 100);
                                }

                                this.productDetailSlider.options.draggable = '>1';
                                this.productDetailSlider.updateDraggable();

                            } else {

                                this.ModelViewerFullScreen('modelviewer', '#modelviewerzoom', false);

                                modelViewer.setAttribute("camera-controls", "");

                                modelViewer.resetTurntableRotation(0);
                                modelViewer.setAttribute("camera-orbit", "45deg 75deg 114%");
                                modelViewer.setAttribute("camera-target", "auto auto auto");
                                modelViewer.setAttribute("auto-rotate", "");

                                this.productDetailSlider.options.draggable = false;
                                this.productDetailSlider.updateDraggable();
                            }

                            /*
                            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {

                                if (modelViewer.requestFullscreen) {
                                    modelViewer.requestFullscreen();
                                }
                                else if (modelViewer.webkitEnterFullScreen) {
                                    modelViewer.webkitEnterFullScreen();
                                }

                            } else {
                                if (document.exitFullscreen) {
                                    document.exitFullscreen();
                                }
                                else if (document.webkitExitFullscreen) {
                                    document.webkitExitFullscreen();
                                }
                            }*/
                        });


                    } else {

                        newSlide2.style = "text-align:center;flex-direction:row;display:flex;margin-top:auto;margin-bottom:auto;flex-flow:column;"

                        //const pcr = document.createElement("picture");

                        //const sc1 = document.createElement("source");

                        //sc1.srcset = asset.href.replace("height=650", "height=200").replace("t_n", "t_nm");
                        //sc1.media = "(max-width:992px)";

                        const newSlideImg = document.createElement('img');
                        newSlideImg.src = asset.href;

                        newSlideImg.setAttribute('data-src-zoom', this.selectedVariant.productFullSizeAssetList[i].href);
                        newSlideImg.setAttribute('alt', this.selectedVariant.imgAltTag);

                        newSlideImg.style = `object-fit:contain;min-height:${sliderHeight};`;

                        newSlide2.appendChild(newSlideImg);
                    }

                    newSlide.appendChild(newSlide2);

                    newSlides.push(newSlide);
                }
          }
        });

        this.productDetailSlider.insert(newSlides, 0);

        //imagesLoaded(this.productDetailSlider.element, () => {
          setTimeout(() => {
            this.productDetailSlider.select(0, false, true);
            if (this.productDetailSlider.cells.length > 1) {
              initThumbNavigation(this.productDetailSlider.element, this.productDetailSlider);
            }
            this.productDetailSlider.resize();
          }, 0);
        //});
      }
    },

    updateCSImageSlider() {

      if (this.crossSellSlider) {

        if (this.crossSellSlider.cells.length) {
            this.crossSellSlider.remove(this.crossSellSlider.cells.map(cell => cell.element));
        }

        if (this.selectedVariant.crossSellProducts.length) {

            const newSlides = [];

            this.selectedVariant.crossSellProducts.forEach((elem, i) => {

                const newSlideDiv1 = document.createElement('div');
                const newSlideDiv2 = document.createElement('div');
                const newSlideDiv3 = document.createElement('div');
                const newSlideDiv4 = document.createElement('div');
                const newSlideA = document.createElement('a');
                const newSlideP = document.createElement('p');
                const newSlideSO = document.createElement('div');

                if (crosssellv2) {

                    newSlideA.href = elem.href;
                    //newSlideDiv2.innerHTML = elem.imgHtml;
                    if (elem.code.startsWith("CM") || elem.code.startsWith("p-CM"))
                        newSlideDiv2.style.cssText = elem.imgStyle142;
                    else
                        newSlideDiv2.style.cssText = elem.imgStyle100;

                    newSlideP.innerHTML = elem.displayName;
                    newSlideSO.innerHTML = elem.soldOnlineHtml;
                    newSlideDiv4.innerHTML = elem.priceHtml;

                    //newSlideDiv3.style.minHeight = '110px';

                    //console.log(crosssellv2);
                    //elem.soldOnline = "true";
                    //elem.soldOnlineHtml = "xxxx";

                    //newSlideDiv1.className = 'product__image--slide';
                    newSlideDiv1.className = 'product__image--slide product__image--featured';
                    //newSlideA.className = 'product product--crosssell product--crosssellv2';
                    newSlideA.className = 'product product--square';
                    //newSlideDiv2.className = 'product__image';
                    newSlideDiv2.className = 'product__image product__image--square';
                    newSlideDiv3.className = 'product__description product__descriptionv2';
                    newSlideP.className = 'product__type';
                    newSlideDiv4.className = 'product__price';
                    newSlideSO.className = 'product__soldonline';

                    if (elem.collectionClass) {
                        const newSlideH = document.createElement('h3');
                        newSlideH.innerHTML = elem.collection;
                        newSlideH.className = elem.collectionClass;
                        newSlideDiv3.appendChild(newSlideH);
                    }

                    newSlideDiv3.appendChild(newSlideP);

                    newSlideDiv3.appendChild(newSlideDiv4);

                    //console.log(elem);
                    if (elem.soldOnline === "true") {
                        newSlideDiv3.appendChild(newSlideSO);
                    }

                    newSlideA.appendChild(newSlideDiv2);
                    newSlideA.appendChild(newSlideDiv3);

                    newSlideDiv1.appendChild(newSlideA);

                    newSlides.push(newSlideDiv1);

                }
                else {

                    newSlideA.href = elem.href;
                    newSlideDiv2.innerHTML = elem.imgHtml;
                    newSlideP.innerHTML = elem.displayName;
                    newSlideSO.innerHTML = elem.soldOnlineHtml;
                    newSlideDiv4.innerHTML = elem.priceHtml;

                    //newSlideDiv3.style.minHeight = '110px';

                    newSlideDiv1.className = 'product__image--slide';
                    newSlideA.className = 'product product--crosssell';
                    newSlideDiv2.className = 'product__image';
                    newSlideDiv3.className = 'product__description';
                    newSlideP.className = 'product__type';
                    newSlideDiv4.className = 'product__price';
                    newSlideSO.className = 'product__soldonline';

                    if (elem.collectionClass) {
                        const newSlideH = document.createElement('h3');
                        newSlideH.innerHTML = elem.collection;
                        newSlideH.className = elem.collectionClass;
                        newSlideDiv3.appendChild(newSlideH);
                    }

                    newSlideDiv3.appendChild(newSlideP);
                    //console.log(elem);
                    if (elem.soldOnline === "true") {
                        newSlideDiv3.appendChild(newSlideSO);
                    }
                    newSlideDiv3.appendChild(newSlideDiv4);

                    newSlideA.appendChild(newSlideDiv2);
                    newSlideA.appendChild(newSlideDiv3);

                    newSlideDiv1.appendChild(newSlideA);

                    newSlides.push(newSlideDiv1);
                }
            });

            this.crossSellSlider.insert(newSlides, 0);
        }

        //imagesLoaded(this.crossSellSlider.element, () => {
            setTimeout(() => {
                this.crossSellSlider.select(0, false, true);
                if (this.crossSellSlider.cells.length > 1) {
                    initThumbNavigation(this.crossSellSlider.element, this.crossSellSlider);
                }
                this.crossSellSlider.resize();
            }, 0);
        //});

      }
    },

    historyBack() {
      window.history.back();
    },
    checkHash() {
        if (window.location.hash !== null) {
            if (window.location.hash.indexOf('config3d') > 0) {
                this.toggleconfigurator3d(false);
            }
        }
     },
     returnDiscount(variant) {

       var discount = 0;

       if (variant.priceAmount > 0 && variant.oldPriceAmount > 0 && variant.priceAmount < variant.oldPriceAmount) {
           discount = (100 * (variant.oldPriceAmount - variant.priceAmount)) / variant.oldPriceAmount;

           if (discount > 0) {
             discount = Math.round(discount);
           }
        }

        return discount;
    },
    returnDiscountText(variant) {

        return variant.discountPercentageText.replace("{0}",this.returnDiscount(variant));
    },
    toggleconfigurator3d(byPopState) {

          app.justAddedToCart = false;

          var footer = document.getElementsByClassName('footer');

          var iframe = document.getElementById('iframeWebGL');

          if (iframe != null) {

              if (!this.configurator3dopen) {
                  window.scroll(0, 0);
              }
              this.configurator3dopen = !this.configurator3dopen;

              if (this.configurator3dopen) {
                  app.showStickyHeader(false);

                  if (footer != null && footer.length > 0) {
                      footer[0].style.display = "none";
                  }

                  var receipt = document.getElementById('roomplannerreceipt');
                  if (receipt != null) {

                      iframe.style.display = "block";

                      receipt.style.display = "none";
                      
                      var backdetailsbutton = document.getElementById('backdetailsbutton');
                      if (backdetailsbutton != null) {
                          backdetailsbutton.style.display = "inline-block";
                      }

                      var receiptbackbutton = document.getElementById('receiptbackbutton');
                      if (receiptbackbutton != null) {
                         receiptbackbutton.style.display = "none";
                      }

                      var receiptbutton = document.getElementById('receiptbutton');
                      if (receiptbutton != null) {
                         receiptbutton.style.display = "none";
                      }
                  }

                  document.body.classList.add('configurator-open');

                  iframe.src =
                      this.colijnurl.replace("ColijnId", this.selectedVariant.colijnId);

                  app.influxDbEvent("Show3dConfigurator");
              } else {
                  app.showStickyHeader(true);

                  if (footer != null && footer.length > 0) {
                      footer[0].style.display = "block";
                  }

                  document.body.classList.remove('configurator-open');
              }
              /*
              if (!byPopState) {
                  if (this.configurator3dopen) {
                      window.history.pushState({ config3d: this.configurator3dopen }, 'deeplink', '#config3d');
                  } else {
                      window.history.pushState({ config3d: this.configurator3dopen },
                          document.title,
                          window.location.pathname);

                  }
              }*/
          }
      }

  }
});
